import { render, staticRenderFns } from "./confirmDelete.vue?vue&type=template&id=2afa2003&lang=pug"
import script from "./confirmDelete.vue?vue&type=script&lang=js"
export * from "./confirmDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports